import { render, staticRenderFns } from "./KYC_v2.vue?vue&type=template&id=a1921ade&scoped=true&"
import script from "./KYC_v2.vue?vue&type=script&lang=js&"
export * from "./KYC_v2.vue?vue&type=script&lang=js&"
import style0 from "./KYC_v2.vue?vue&type=style&index=0&id=a1921ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1921ade",
  null
  
)

export default component.exports